export default function rating({ variables }) {
    return {
        MuiRating: {
            styleOverrides: {
                root: {
                    fontSize: "1.125rem",
                },
                iconFilled: {
                    color: variables.interactive,
                },
                iconEmpty: {
                    color: variables.border_strong,
                },
                iconHover: {
                    color: variables.interactive_hover,
                },
            },
        },
    };
}
//# sourceMappingURL=rating.js.map